import api from '../api'
import { useQuery } from '@tanstack/react-query'
import { ApiRouteEnum } from '../../enums/ApiRouteEnum'
import { ICompanyV2 } from '../../interfaces/entities/ICompany'
import queryString from 'query-string'
import { ICompanyDiscounts } from '../../interfaces/entities/ICompanyDiscounts'
export const useGetCompanyDiscount = (params: {companyId?: number}) => {
  const query = queryString.stringify(
    params,
    { skipEmptyString: true },
  )
  return useQuery(
    [ApiRouteEnum.COMPANY_DISCOUNT, params],
    () => api.get<ICompanyDiscounts[]>(`${ApiRouteEnum.COMPANY_DISCOUNT}?${query}`),
    { retry: false },
  )
}
